import { styled as StyledMui } from "@mui/system";
import { Box, Typography } from "@mui/material";
import { laptopMQL } from "../../utils/constant";

export const CardBox = StyledMui(Box)(() => ({
  height: "30rem",
  width: "27rem",
  borderRadius: "1rem",
  boxShadow: "13px 7px 19px 8px rgba(0,0,0,0.2)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "4.5rem",
  cursor: "pointer",
  [laptopMQL]:{
    height:"25.5rem",
    width:"23rem"
  }
}));

export const CardTextAndCount = StyledMui(Box)((props) => ({
 display:"flex",
 justifyContent:"center",
  color: props.ishover === "true" ? "#CF2030" : "#676767",
  width: "100%",
}));
export const CardText = StyledMui(Typography)((props) => ({
  fontSize: "1.5rem",
  fontWeight: "700",
  color: props.ishover === "true" ? "#CF2030" : "#676767",
  textOverflow: "ellipsis",
  overflow: "hidden",
}));

export const ConnectionsTextBox = StyledMui(Box)(() => ({
  flexBasis: "23%",
  alignSelf: "flex-start",
}));
